<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [dataLabels]="chartOptions.dataLabels!"
        [yaxis]="chartOptions.yaxis!"
        [colors]="chartOptions.colors!"
        [legend]="chartOptions.legend!"
        [grid]="chartOptions.grid!"
        [fill]="chartOptions.fill!"
    ></apx-chart>
</div>